import type { paths } from '@pba/types-openapi-client';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type OrganizationsRequestParams = paths['/v3/organizations']['get']['parameters']['query'];
type ResponseType = paths['/v3/organizations']['get']['responses']['200']['content']['application/json'];

export const getOrganizations = async ({ config: { params } }: ConfigRequest<OrganizationsRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.organizations.find, { params });
